import React from "react";
import {
  JobConfigurationProvider,
  useJobConfigurationContext,
} from "../../../../contexts/JobConfigurationContext";
import QAConfigurationDialog from "./QAConfigurationDialog";
import JobConfigurationDialog from "./JobConfigurationDialog";

function DialogMapper({selectedUsers}) {
  return (
      <DialogRenderer selectedUsers={selectedUsers}/>
  );
}

function DialogRenderer({selectedUsers, setPipelineJobName}) {
  const { activeJob } = useJobConfigurationContext();
  if (!activeJob) {
    return null;
  }

  if (activeJob.mapping_value === "qa") {
    return <QAConfigurationDialog selectedUsers={selectedUsers}/>;
  } else if (activeJob.mapping_value === "job") {
    return <JobConfigurationDialog selectedUsers={selectedUsers}/>;
  }
  return null;
}

export default DialogMapper;
